import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { ICON_COMPONENTS } from './constants';
import { TooltipContent, TooltipIconWrapper, TooltipWrapper } from './styled';

export type Props = {
  id?: string;
  icon: {
    name: string;
    tooltip?: string | JSX.Element;
    svg?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  };
  onClick?: (name: string) => void;
  disabled?: boolean;
  isCampaign?: boolean;
  dataTestId?: string;
  className?: string;
  hidden?: boolean;
  whiteTheme?: boolean;
};

const IconComponent = ({
  id,
  icon,
  onClick,
  disabled,
  isCampaign = false,
  dataTestId,
  className = 'TooltipIconWrapperComponent',
  hidden = false,
  whiteTheme = false,
}: Props): JSX.Element => {
  const Icon = icon.svg || ICON_COMPONENTS[icon.name as keyof typeof ICON_COMPONENTS];
  const disabledString = disabled ? '-disabled' : '';
  const isCampaignString = isCampaign ? '-campaign' : '';
  const elementId = `descriptionTooltip-${icon.name}${id ? `-${id}` : ''}-click${disabledString}${isCampaignString}`;
  const elementTestId = `descriptionTooltip-${icon.name}-click${disabledString}${isCampaignString}`;

  const handleClick = (): void => {
    if (!disabled) {
      onClick?.(icon.name);
    }
  };

  return (
    <TooltipWrapper data-testid={dataTestId || icon.name} hidden={hidden} $whiteTheme={whiteTheme}>
      {icon.tooltip && (
        <ReactTooltip id={elementId} className="descriptionTooltip" opacity={1}>
          <TooltipContent data-testid={`descriptionTooltip-${icon.name}${disabledString}`} $whiteTheme={whiteTheme}>
            {icon.tooltip}
          </TooltipContent>
        </ReactTooltip>
      )}
      <TooltipIconWrapper
        data-testid={elementTestId}
        data-tooltip-id={elementId}
        onClick={handleClick}
        disabled={!!disabled}
        className={className}
      >
        {Icon && <Icon />}
      </TooltipIconWrapper>
    </TooltipWrapper>
  );
};

export default IconComponent;
